import React, { useState } from "react";
import ProductBox from "../components/ProductBox";
import CustomButton from "../components/CustomButton";
import { useLocation, useNavigate } from "react-router-dom";
import { getQuoteMock } from "./mock";
import { ProductType } from "../enums/ProductType";
import { QuoteResponse } from "../interfaces/QuoteResponse";

const Success = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const [mock] = useState(getQuoteMock());

  const getQuote = (name: string): QuoteResponse =>
    state?.data.find(
      (q: QuoteResponse) => q.offer.product.productName === name,
    );

  return (
    <div className="px-5 pt-28 relative">
      <div className="text-center mb-7">
        <div className="text-3xl font-semibold mb-3">Request sent!</div>
        <p className="text-lg">You will shortly receive the quote via email:</p>
      </div>
      <div className="flex flex-col gap-5">
        <ProductBox
          quote={getQuote(ProductType.GUARD)}
          customerId={state?.customerId}
        />
        <ProductBox
          quote={getQuote(ProductType.PROTECTOR)}
          customerId={state?.customerId}
        />
        <ProductBox
          quote={getQuote(ProductType.GUARDIAN)}
          customerId={state?.customerId}
        />
      </div>
      <div className="py-5">
        <CustomButton onClick={() => navigate(`/${state.customerId}`)}>
          Back to start
        </CustomButton>
      </div>
    </div>
  );
};

export default Success;
